export const filterEmailsList = obj => {
  const emailsArr = [];

  obj.data.forEach(departmentItem => {
    if (
      departmentItem &&
      departmentItem.relationships &&
      departmentItem.relationships.email_channel &&
      departmentItem.relationships.email_channel.data &&
      Array.isArray(departmentItem.relationships.email_channel.data)
    ) {
      departmentItem.relationships.email_channel.data.forEach(
        relatedEmailItem => {
          const emailData = obj.included.find(
            item => item.id === relatedEmailItem.id,
          );

          if (emailData && emailData.attributes && emailData.attributes.email)
            emailsArr.push({
              email: emailData.attributes.email,
              isDefault: emailData.attributes.is_default,
              active: emailData.attributes.active,
              department: departmentItem.attributes.name,
            });
        },
      );
    }
  });

  return emailsArr;
};
